import { create } from 'zustand';

interface NotificationStore {
  unreadCount: number;
  eventSource: EventSource | null;
  setUnreadCount: (count: number) => void;
  incrementUnreadCount: () => void;
  connect: (apiUrl: string) => void;
  disconnect: () => void;
}

export const useNotificationStore = create<NotificationStore>()((set, get) => ({
  unreadCount: 0,
  eventSource: null,

  setUnreadCount: (count) => set({ unreadCount: count }),
  incrementUnreadCount: () => set((s) => ({ unreadCount: s.unreadCount + 1 })),

  connect: (apiUrl: string) => {
    const existing = get().eventSource;
    if (existing) return;

    const url = `${apiUrl}/notifications/stream`;
    const es = new EventSource(url, { withCredentials: true });

    es.onmessage = () => {
      get().incrementUnreadCount();
    };

    es.onerror = () => {
      es.close();
      set({ eventSource: null });

      setTimeout(() => {
        if (!get().eventSource) {
          get().connect(apiUrl);
        }
      }, 5000);
    };

    set({ eventSource: es });
  },

  disconnect: () => {
    const es = get().eventSource;
    if (es) {
      es.close();
      set({ eventSource: null });
    }
  },
}));
